




































import { Vue, Component, Prop } from 'vue-property-decorator';
import { Survey } from '../../model/api';
import AppBase from '../common/base';

@Component
export default class SurveyChooser extends AppBase {
    isNew = true;

    surveys: any = [];

    async created() {
        this.$store.commit('clearTheme');
        this.setLoading(true);
        this.updateData(await this.$store.dispatch('listSurveys'));
        this.setLoading(false);
    }

    private updateData(data: any) {
        this.surveys = data.filter(x => !!x.texts[this.lang] && !!x.texts[this.lang].Title);
    }

    getSurveyTitle(survey: Survey) {
        return this.getText(survey.texts, 'Title');
    }

    getSurveyTagline(survey: Survey) {
        return this.getText(survey.texts, 'Tagline');
    }
}




// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/app/surveys/survey-chooser.vue